import {withFormsy} from 'formsy-react';
import React from 'react';
import ExperienceGroup from "../ExperienceGroup";

let ExperienceRadio = (props) => {

    console.error('THIS COMPONENT IS NOT BEING USED - YOU MUST PASS IN KEYS wants_junior_experience, wants_intermediate_experience, AND wants_senior_experience TO USE THE ExperienceGroup COMPONENT BELOW')

    const errorMessage = props.getErrorMessage();

    const invalid = !props.isValid() && props.isFormSubmitted();
    let className = TB.mapClass(props.className || "", {
        required: props.showRequired(),
        "text-danger": invalid
    });

    let experienceLevel = null;
    if(props.value && laravel.talent_experience_levels[parseInt(props.value)] ) {
        experienceLevel = laravel.talent_experience_levels[parseInt(props.value)];
    }
    return (
        <div className={"form-group experience-radio-group " + className}>
            {props.label !== false && (
                <label className="col-form-label"
                       data-required={props.required}>
                    {props.label || 'Please select an option'}
                </label>
            )}
            {props.help && (
                <p className="form-help">
                    {props.help}
                </p>
            )}



            <input
                type="hidden"
                name={props.name}
                tabIndex={props.isReadOnly ? -1 : undefined}
                required={props.required}
                disabled={props.disabled}/>

            <ExperienceGroup
                disabled={props.disabled}
                formError={invalid}
                minSelected={props.value ? parseInt(props.value) : null}
                onClick={value => props.setValue(value)}/>

            {experienceLevel && (
                <p className="experience-selected-info">
                    Minimum years experience selected:&nbsp;
                    <b>{`${experienceLevel.level} (${experienceLevel.label})`}</b>
                </p>
            )}

            {errorMessage && (
                <span className={'invalid-feedback'}>
                    {errorMessage}
                </span>
            )}
        </div>
    )
}

const ExperienceRadioGroup = withFormsy(ExperienceRadio);

export default ExperienceRadioGroup;